import Place from "@wikicasa/common/model/Place";
//@ts-ignore
import {GPlaceDetails} from "@customTypes/GAutocompleteTypes";
//@ts-ignore
import {cleanASCII, formatAddress} from "@utils/StringUtils";
//@ts-ignore
import {getPlacesDetails, guessPlace} from "@services/geographyAPI";

export const googlePlaceConverter = async (gPlace: GPlaceDetails, address: string): Promise<Place> => {
    const place = {} as Place;

    for (let i = 0; i < gPlace["address_components"].length; i++) {
        if (gPlace["address_components"][i].types.indexOf("administrative_area_level_3") !== -1) {
            place.city = gPlace["address_components"][i].long_name;
        } else if (gPlace["address_components"][i].types.indexOf("locality") !== -1) {
            place.locality = gPlace["address_components"][i].long_name;
        } else if (gPlace["address_components"][i].types.indexOf("route") !== -1) {
            place.streetName = gPlace["address_components"][i].long_name;
        } else if (gPlace["address_components"][i].types.indexOf("street_number") !== -1) {
            place.streetNumber = gPlace["address_components"][i].long_name;
        } else if (gPlace["address_components"][i].types.indexOf("postal_code") !== -1) {
            place.zip = gPlace["address_components"][i].long_name;
        }
    }

    place.latitude = gPlace["geometry"].location.lat;
    place.longitude = gPlace["geometry"].location.lng;

    place.address = cleanASCII(address);

    if (typeof place.streetNumber === "undefined")
        place.streetNumber = null;

    let res = await guessPlace(place.latitude, place.longitude)

    delete res.city;
    delete res.locality;

    res = {...res, ...place};

    /* FIX FOR GOOGLE AUTOCOMPLETE MISSING STREET NUMBER */
    if (!res.streetNumber) {
        const term = parseInt(res.address.split(",")[1]);
        const zip = parseInt(res.zip);

        if (term && term !== zip)
            res.streetNumber = term.toString();
    }

    return res;
}

export const getPlaceFromGAutocomplete = async (placeId: string, label: string): Promise<{ place: Place; address: string }> => {
    const gPlaceDetails = await getPlacesDetails(placeId);
    const place = await googlePlaceConverter(gPlaceDetails, label);
    const address = place.streetName ? formatAddress(place.streetName, place.streetNumber || "", place.cityName) : place.address;
    return {place, address};
}